import { DISCLAIMER } from "@checkone/contract/client";
import type { ReactNode } from "react";
import { isApiError } from "../api/client";

function Disclaimer() {
  return <p className="disclaimer">{DISCLAIMER}</p>;
}

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <Disclaimer />
        <p style={{ margin: "var(--space-1) 0 0" }}>
          Arure Technologies (Pvt) Ltd · CheckOne by FormOne · Times in Pakistan time (PKT)
        </p>
      </div>
    </footer>
  );
}

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className="row">{actions}</div>}
    </div>
  );
}

export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="loading" role="status">
      {label}
    </div>
  );
}

export function ErrorState({ error, retry }: { error: unknown; retry?: () => void }) {
  return (
    <div className="callout danger" role="alert">
      <p>
        <strong>{isApiError(error) ? error.message : "Something went wrong."}</strong>
      </p>
      {isApiError(error) && error.requestId && (
        <p className="subtle">
          Reference: <span className="mono">{error.requestId}</span>
        </p>
      )}
      {retry && (
        <button className="btn small" onClick={retry}>
          Try again
        </button>
      )}
    </div>
  );
}

const ICONS = {
  upload: "M12 16V4m0 0l-4 4m4-4l4 4M4 16v3a1 1 0 001 1h14a1 1 0 001-1v-3",
  download: "M12 4v12m0 0l-4-4m4 4l4-4M4 16v3a1 1 0 001 1h14a1 1 0 001-1v-3",
  "arrow-left": "M19 12H5m0 0l6-6m-6 6l6 6",
  "arrow-right": "M5 12h14m0 0l-6-6m6 6l-6 6",
  file: "M14 3H7a1 1 0 00-1 1v16a1 1 0 001 1h10a1 1 0 001-1V7l-4-4zm0 0v4h4",
} as const;

/** Inline stroke icon; decorative unless given a label. */
export function Icon({
  name,
  size = 16,
  label,
}: {
  name: keyof typeof ICONS;
  size?: number;
  label?: string;
}) {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={label ? undefined : true}
      role={label ? "img" : undefined}
      aria-label={label}
    >
      <path d={ICONS[name]} />
    </svg>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="empty">{children}</div>;
}

export function Stat({
  value,
  label,
  tone,
}: {
  value: ReactNode;
  label: string;
  tone?: "danger" | "ok" | "warn";
}) {
  return (
    <div className={`stat ${tone ?? ""}`}>
      <div className="value">{value}</div>
      <div className="label">{label}</div>
    </div>
  );
}
